import React, { useMemo } from 'react';
import Dialog from "@material-ui/core/Dialog";
import { withStyles } from "@material-ui/core/styles";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import DialogTitle from "./DialogTitle";

const DialogContent = withStyles(() => ({
  root: {
    //padding: theme.spacing(2),
    padding: 0,
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const RmDialog = ({
  children,
  title = 'Dialog',
  visibile = true,
  onClose,
  showFooter = true,
  footerActions,

}) => {


  console.log("---RmDialog");

  const dialogFooter = useMemo(() => (
    <Button
      className="mb-3"
      style={{ fontWeight: "600" }}
      variant="contained"
      onClick={onClose}
      color="primary"
    >
      Cancel
    </Button>
  ), [onClose]);

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog"
      //TransitionComponent={Transition}
      open={visibile}
      PaperProps={{
        style: {
          borderRadius: "1rem",
          minWidth: "400px",
          margin: 20,
        }
      }}
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={onClose}
      >
        {title}
      </DialogTitle>
      <DialogContent dividers>
        {children}
      </DialogContent>
      {
        showFooter &&
        <DialogActions>
          {footerActions || dialogFooter}
        </DialogActions>
      }
    </Dialog>
  );
};

export default RmDialog;